import React from 'react';
import styled from '@emotion/styled';

import { breakpoints, fontWeight } from '~/src/styles';

interface Props {
  content: {
    title: string;
  };
}

const H1 = styled.h1`
  font-size: 22px;
  font-weight: ${fontWeight.semiBold};
  line-height: 30px;
  letter-spacing: 0.03em;
  text-align: left;
  color: white;
  margin-bottom: 36px;

  ${breakpoints.minTablet} {
    margin-bottom: 16px;
  }

  ${breakpoints.minDesktop} {
    font-size: 35px;
    line-height: 48px;
    text-align: left;
  }
`;

export const Title: React.FC<Props> = ({ content: { title } }) => {
  return <H1>{title}</H1>;
};
